<template>
  <div class="hostel-expense-container">
    <template v-for="i in searchInput">
      <el-input
        :key="i.model"
        v-model="search[i.model]"
        style="width: 200px; margin-right: 10px"
        :placeholder="i.label"
      ></el-input>
    </template>
    <el-select v-model="search.case" style="width: 200px; margin-right: 10px">
      <el-option label="已交費" :value="1"></el-option>
      <el-option label="未交費" :value="2"></el-option>
    </el-select>
    <el-button size="small" type="primary" @click="reset">{{
      $t("app.reset")
    }}</el-button>
    <div style="padding: 10px 0">
      <el-button
        type="success"
        icon="el-icon-search"
        size="small"
        @click="getList"
        >{{ $t("app.search") }}</el-button
      >
      <el-button type="primary" @click="getList">高級查詢</el-button>
      <el-button type="primary" style="float: right">獲取更新</el-button>
      <el-button
        type="primary"
        style="float: right"
        @click="dialogVisible = true"
        >截止繳費日期</el-button
      >
    </div>
    <el-table :data="tableData" style="width: 100%; color: black">
      <el-table-column
        align="center"
        width="150px"
        :label="$t('app.operation')"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="adjust(scope.row)">{{
            $t("app.adjustment")
          }}</el-button>
          <el-button
            size="small"
            type="danger"
            @click="getRecord(scope.row.billId)"
            >痕跡</el-button
          >
        </template>
      </el-table-column>
      <template v-for="col in column">
        <el-table-column
          :key="col.model"
          align="center"
          :label="col.label"
          :prop="col.model"
        >
          <template slot-scope="scope">
            <template v-if="col.model === 'nameEnglish'">
              <div style="word-break: normal">
                {{ scope.row[col.model] }}
              </div>
            </template>
            <template v-else>
              {{ scope.row[col.model] }}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      title="繳費截止日期設置"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <div style="height: 60px; line-height: 60px">
        第一學期繳費截止日期:
        <el-date-picker
          type="date"
          :placeholder="$t('app.validation.date')"
          value-format="HH:mm"
          v-model="dateFirst"
          style="width: 200px"
        ></el-date-picker>
      </div>
      <div style="height: 60px; line-height: 60px">
        第二學期繳費截止日期:
        <el-date-picker
          type="date"
          :placeholder="$t('app.validation.date')"
          value-format="HH:mm"
          v-model="dateSecond"
          style="width: 200px"
        ></el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="dialogVisible = false"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="住宿費調整" :visible.sync="adjustVisible" width="500px">
      <el-row class="adjust">
        <el-col :span="24">
          流水號:
          {{ target.billId }}
        </el-col>
        <el-col :span="12">
          英文名:
          {{ target.nameEnglish }}
        </el-col>
        <el-col :span="12">
          中文名:
          {{ target.nameEnglish }}
        </el-col>
        <el-col :span="12">
          學生編號:
          {{ target.studentNumber }}
        </el-col>
        <el-col :span="12">
          費用類型:
          {{ target.type }}
        </el-col>
        <el-col :span="12">
          總費用:
          <el-input
            v-model="target.total"
            style="width: 170px"
            size="small"
          ></el-input>
        </el-col>
        <el-col :span="12">
          交費狀態:
          {{ target.status }}
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="adjustVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="adjustVisible = false"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <record ref="record"></record>
  </div>
</template>

<script>
import { getList } from "@/api/dormitoryManagement/overnight";
import { delEmpty } from "@/utils/utils";
import Record from "./modules/Record";
export default {
  components: { Record },
  data() {
    return {
      target: {
        billId: "",
        nameEnglish: "",
        nameChina: "",
        studentNumber: "",
        type: "",
        total: "",
        status: "",
      },
      adjustVisible: false,
      dateFirst: "",
      dateSecond: "",
      loading: false,
      dialogVisible: false,
      searchInput: [
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        { model: "name", label: this.$t("app.name") },
      ],
      column: [
        { model: "billId", label: "流水號" },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "type",
          label: "費用類型",
        },
        {
          model: "total",
          label: "總費用",
        },
        {
          model: "status",
          label: "交費狀態",
        },
      ],
      search: {
        room: "",
        studentNumber: "",
        contact: "",
        name: "",
        case: "",
      },
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [{}],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getRecord(id) {
      this.$refs.record.visit(id);
    },
    adjust(row) {
      for (let i in row) {
        this.target[i] = row[i];
      }
      this.adjustVisible = true;
    },
    getList() {
      getList(
        delEmpty({
          RoomIndex: this.search.room,
          StudentName: this.search.name,
          StudentCode: this.search.studentNumber,
          ContactMobile: this.search.contact,
          Result: this.search.case,
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            room: item.CurrentRoom,
            nameEnglish: item.EnglishName,
            studentNumber: item.StudentCode,
            case: item.ApplyReason,
            contactInformation: item.ContactMobile,
            date: item.ApplyDate,
            items: item.ApplyItem,
          };
        });
      });
    },
    reset() {
      this.search.studentNumber = "";
      this.search.name = "";
      this.search.case = "";
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.hostel-expense-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
  .adjust {
    .el-col {
      height: 40px;
      line-height: 40px;
    }
  }
}
</style>
